import { MetaAttributes, MetaSession, MetaUser } from '@grafana/faro-web-sdk';
import { useInterpret, useSelector } from '@xstate/react';
import { createContext, useContext } from 'react';

import { usePushMeasurementToFaro } from './faro-measurement-performance-observer';
import { createRumMachine, type RumMethods } from './rum-machine';

export type FaroMetaSession = MetaSession;
export type FaroMetaAttributes = MetaAttributes;

const initialMethods: RumMethods = {
  pushError: () => {
    console.warn("Can't push error without a Rum provider");
  },
  pushMeasurement: () => {
    console.warn("Can't push Rum signal without a Rum provider");
  },
  getSession: () => {
    return {};
  },
  setUser: () => {
    return {};
  },
  setSession: () => {
    return {};
  },
};

const RumContext = createContext<RumMethods>(initialMethods);

export type FaroMetaUser = MetaUser;

export function useRum() {
  return useContext(RumContext);
}

export const RumProvider = (
  props: React.PropsWithChildren<Parameters<typeof createRumMachine>[0]>,
) => {
  const rumService = useInterpret(() => createRumMachine(props));
  const rumMethods = useSelector(
    rumService,
    (state) => state.context.methods ?? initialMethods,
  );
  usePushMeasurementToFaro();
  return (
    <RumContext.Provider value={rumMethods}>
      {props.children}
    </RumContext.Provider>
  );
};
